import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { MetaUpdateData } from '../models/common.interfaces';

@Injectable({
  providedIn: 'root',
})
export class MetaService {
  private readonly DEFAULT_TITLE =
    'Verto: Cross-border payments platform for businesses';
  private readonly DEFAULT_DESCRIPTION =
    'Verto: Cross-border payments platform for businesses across the globe.';

  constructor(
    private router: Router,
    private meta: Meta,
    private title: Title
  ) {}

  updateMeta(data?: MetaUpdateData): void {
    const titleToSet = data?.title || this.DEFAULT_TITLE;
    const descriptionToSet = data?.description || this.DEFAULT_DESCRIPTION;

    this.title.setTitle(titleToSet);

    this.meta.updateTag({
      name: 'description',
      content: descriptionToSet,
    });

    if (data?.keywords) {
      this.meta.updateTag({
        name: 'keywords',
        content: data.keywords,
      });
    }

    if (data?.author) {
      this.meta.updateTag({
        name: 'author',
        content: data.author,
      });
    }
  }

  updateOG(data: MetaUpdateData): void {
    if (data.title) {
      this.meta.updateTag({
        property: 'og:title',
        content: data.title,
      });
    }

    if (data.description) {
      this.meta.updateTag({
        property: 'og:description',
        content: data.description,
      });
    }

    if (data['url']) {
      const url = `https://verto.co${data['url']}`;
      this.meta.updateTag({
        property: 'og:url',
        content: url,
      });
      this.meta.updateTag({
        property: 'twitter:url',
        content: url,
      });
    }

    if (data['image']) {
      const imageUrl = `https:${data['image']}`;
      this.meta.updateTag({
        property: 'og:image',
        content: imageUrl,
      });
      this.meta.updateTag({
        property: 'twitter:image',
        content: imageUrl,
      });
    }

    if (data['type']) {
      this.meta.updateTag({
        property: 'og:type',
        content: data['type'],
      });
    }

    if (data.title) {
      this.meta.updateTag({
        property: 'twitter:title',
        content: data.title,
      });
    }

    if (data.description) {
      this.meta.updateTag({
        property: 'twitter:description',
        content: data.description,
      });
    }
  }
}
